export const FLOW_NAME = "outcome-driver-analysis";
export type FLOW_TYPE = "outcome-driver-analysis";

export const INPUT_DATA = "input-data";
export const OUTCOME_TYPE = "outcome-type";

export const OUTCOME_DEFINITION = "outcome-definition"; // For Discrete Y
export const Y_COLUMNS = "y-columns"; // For Continous Y
export const OUTCOME_COLUMN_NAME = "outcome-column";

export const TIME_VARIABLE = "time-column";
export const GROUPING_VARIABLES = "group-vars";
export const LABEL_VARIABLES = "id-vars";
export const ENTITY_VARIABLES = "entity-vars";

export const TIME_RESOLUTION = "time-resolution";

export const WORKSPACE_OUTCOME_VARIABLE = "outcome-variable";

export const AUGMENTED_FILE = "augmented-data";

export const BINARY_Y_RECIPE =
  "what-is-the-probability-of-y-happening-generic-recipe-single-file";

export const CONTINOUS_Y_RECIPE =
  "what-is-y-likely-to-be-regression-single-file";

export const BINARY_ALGOS = [
  "boosted-trees",
  "bayesian-probit",
  "supervised-clustering",
];
export const REGRESSION_ALGOS = [
  "boosted-trees",
  "bayesian-nig",
  // "elastic-net",
];

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";
